import { Box, SvgIcon, Tooltip, Typography } from "@mui/material";
import { Information } from "@opengov/react-capital-assets";
import { ElementType } from "react";
import { useIntl } from "react-intl";
import { styles } from "./DialogFooter-styles";

export const DialogFooter = () => {
  const intl = useIntl();
  return (
    <Box sx={styles.container}>
      <Tooltip
        title={intl.formatMessage({
          defaultMessage:
            "Proposals and Worksheets show results from the current budget while Reports, Workforce, Stories & Publication show results from the entity/organization level. Toggle the switch above to search items across all budgets.",
        })}
        placement="left-end"
      >
        <Typography sx={styles.learnAboutResults} component="span" variant="body2">
          <SvgIcon
            component={Information as ElementType}
            data-testid="InfoIcon"
            inheritViewBox
            sx={styles.infoIcon}
            fontSize="inherit"
          />
          {intl.formatMessage({ defaultMessage: "Learn about results" })}
        </Typography>
      </Tooltip>
    </Box>
  );
};
